import React from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import {getFilteredFeatures, getShippingSetupList} from "../featuresFunctions";
import {shippingSetupContextAction, useShippingSetupContext} from "./FeaturesSetupShippingSetupContext";
import {usePrevious} from "../../../utilities/helperHooks";
import {featuresSetupUpdateFeatures} from "../featuresActions";

const FeaturesSetupShippingSetupPopupLeft = (props) => {

  const {intl, featuresSetupUpdateFeatures} = props;

  const {shippingSetupContextState, shippingSetupContextDispatch} = useShippingSetupContext();
  const {shippingSetupList, activeShippingCostIndex, shippingCostValue} = shippingSetupContextState;

  const updateDisabled = activeShippingCostIndex < 0 || !shippingSetupList[activeShippingCostIndex]
    || !shippingSetupList[activeShippingCostIndex].features
    || shippingSetupList[activeShippingCostIndex].features.every(feature => feature.shippingCost === shippingCostValue)

  const shippingCostChange = (event) => {
    shippingSetupContextDispatch(shippingSetupContextAction({
      shippingCostValue: event.target.value,
    }))
  }

  const updateClick = () => {
    if (updateDisabled) {
      return false
    }
    if (shippingSetupList[activeShippingCostIndex]) {
      featuresSetupUpdateFeatures(["shippingCost"],  [shippingCostValue], shippingSetupList[activeShippingCostIndex].features)
    }
  }

  // const addClick = () => {
  //   shippingSetupContextDispatch(shippingSetupContextAction({
  //     shippingSetupList: [...shippingSetupList, {
  //       shippingName: "",
  //       shippingCost: shippingCostValue,
  //       shippingTime: "",
  //       features: [],
  //       isCustom: true
  //     }],
  //   }))
  // }

  return (
    <div className="fs-shipping-setup__cell fs-shipping-setup__cell--left">
      <input className="generic-popup-textbox"
             placeholder={intl.formatMessage({id: "features.setup.feature.placeholder.shippingCost"})}
             maxLength={255} value={shippingSetupContextState.shippingCostValue || ""}
             onChange={shippingCostChange}/>
      <input className="generic-popup-textbox generic-popup-textbox--disabled" placeholder="Width" maxLength={255} value={""}
             onChange={() => {}}/>
      <input className="generic-popup-textbox generic-popup-textbox--disabled" placeholder="Height" maxLength={255} value={""}
             onChange={() => {}}/>
      <input className="generic-popup-textbox generic-popup-textbox--disabled" placeholder="Depth" maxLength={255} value={""}
             onChange={() => {}}/>
      <input className="generic-popup-textbox generic-popup-textbox--disabled" placeholder="Product Weight" maxLength={255} value={""}
             onChange={() => {}}/>
      <div className="fs-shipping-setup__buttons">
        <button className={"ui-button5 ui-button5--wide ui-button5--blue" + (updateDisabled ? " ui-button5--disabled" : "")}
                onClick={updateClick}>
          <FormattedMessage id="messageBox.buttons.update"/>
        </button>
        {/*<button className={"ui-button5 ui-button5--green" + (activeShippingCostIndex > -1 || !shippingCostValue ? " ui-button5--disabled" : "")}*/}
        {/*        onClick={addClick}>*/}
        {/*  <FormattedMessage id="messageBox.buttons.add"/>*/}
        {/*</button>*/}
      </div>
    </div>
  )
};

FeaturesSetupShippingSetupPopupLeft.propTypes = {
}

const mapStateToProps = (store) => {
  const featuresList = getFilteredFeatures(store, false, true);
  const selectedFeaturesList = getFilteredFeatures(store, true, true);

  return {
    featuresList,
    selectedFeaturesList,
  };
};

const mapDispatchToProps = {
  featuresSetupUpdateFeatures,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupShippingSetupPopupLeft)
)
